import { useState } from 'react';
import VoteCard from './voteCard';
import QrModal from './qrModal';
// import VoteCard,{voteExtToggle , setVoteExtToggle} from './voteCard';
import Vote  from './vote';
import Timer from '../features/timer';
import { useEffect } from 'react';
import {AppState} from '../context/AppProvider'
import axios from 'axios'

let seedVotes = require('../seeders/seedVotes.json');


let cur_user 
// = JSON.parse(window.localStorage.getItem('cur_user'))
// const meetings = JSON.parse(window.localStorage.getItem('meetings'))
// const meeting = JSON.parse(window.localStorage.getItem('meeting'))
// const vote= JSON.parse(window.localStorage.getItem('vote'))

 

function getCardInfo(){
   const PORT=3000
   const MONGO_URI="mongodb://localhost:27017/votes"
}

// const  votes = currentMeeting?.votes//? meeting?.votes : seedVotes
//  function generateVotes(view){
//    let vote_map = currentMeeting?.votes?.map((vote,index) => {
//       return (<VoteCard vote={vote} key={index} view ={view} />)
//    })
//    return vote_map   
// }

 function Meeting(props) {
   // const {_id,title,type,orgnaization_name,time_handling ,link,material_links,host,admin,attendees,topics,attendance,votes,status,end}  =  meeting
  const {isLoggedIn, 
        setIsLoggedIn,
        room,
        setRoom,
      //   view,
        setView,
        user,
        setUser,
        OM_user, 
        setOM_user,
        TC_user, 
        setTC_user,
        currentMeeting, 
        setCurrentMeeting,
        notifications,
        setNotifications,
        isLoading,
        setIsLoading } = AppState()

   // if (!currentMeeting){setCurrentMeeting(JSON.parse(localStorage.getItem('meeting')))}

   const {_id,title,type,host,orgnaization_name,time_handling ,link,material_links,createdBy,admin,attendees,topics,attendance,votes,status,end}  =  currentMeeting
   const view = props.view
   const [showAdmin , setShowAdmin] = useState(false)
   const [loading , setLoading] = useState(false)
   const [showDuration , setShowDuration] = useState(false)
   const [time, setTimer] = useState('')
   const mm_btn_opn = 'frame-mm-button show-box blink'
   const mm_btn_cls = 'frame-mm-button-close show-box blink'
   const [mtgVtPos, setMtgVtPos] = useState('slide-up')
   const [mtgVtBox, setMtgVtBox] = useState(false)
   const [vidLinkMod, setVidLinkMod] = useState('')
   const [ showQr , setShowQr ] = useState(false)
   const [ qrPos , setQrPos ] = useState('qr-down')
   const [ curIntervals, setCurIntervals ] = useState()
   let time_class = `${time_handling} blink-slower`

   let vc_vt_toggle
    // const launch_date = `2023-03-01T08:00:00Z`
   //  let [time, setTimer] = useState()
   let status_class =`${status} blink`

   const OM_API_Local = 'http://localhost:5001/api'
   const OM_API = 'https://open-mic-api.onrender.com/api'

   const  checkIds =(plat,user)=>{
      if ( plat === 'OM' ){ return user.OM_id }
      if ( plat === 'TC' ){ return user.TC_id }
   }
   const createOMRoom  = async() =>{
      try {
         console.log("[OM_user.token]: ",OM_user?.token)
      const config = {
        headers: {
          "Content-type": "application/json",
           Authorization: `Bearer ${OM_user?.token}`,
        },
      };
      // setIsOnline(true)
      let OM_Guests = attendees?.map(a=>a.OM_id)
      console.log('OM_Guests:',OM_Guests)
      if(!OM_Guests?.find(g =>checkIds('OM',admin))){OM_Guests?.push(admin?.OM_id)}
      if(!OM_Guests?.find(g =>checkIds('OM',host))){OM_Guests?.push(host?.OM_id)}
      if(!OM_Guests?.find(g =>checkIds('OM',createdBy))){OM_Guests?.push(createdBy?.OM_id)}
      console.log('OM_Guests:',OM_Guests)
     
      const { data } = await axios.post(
      //   `${ENV_ENDPOINT[0]}/api/user/login`,
        `${OM_API}/room/create`,
        {
          guests: OM_Guests,
          roomName: title,
          linkage: true,
        },
        config
      );

      setRoom(data)
      console.log("[Room Created]:",room?.roomName);
      // setActionError('login successful')
      
      localStorage.setItem("OM_room", JSON.stringify(data));
     
        setLoading(false);
      //   setIsRoomLoading(true)
        setIsLoggedIn(true)
    
      } catch (error) {
        console.log(error)
        setIsLoggedIn(false)
      setLoading(false);
    }

   }

   const  vts = currentMeeting?.votes? currentMeeting?.votes : props.meeting.votes//seedVotes
   function generateVotes(view){
      // console.log('votes:', props.meeting)
      let vote_map = vts?.map((vote,index) => {
      // let vote_map = currentMeeting?.votes?.map((vote,index) => {
         return (
            <>
               {vote && (<VoteCard vote={vote} key={index} view ={view} />)}
            </>
         )
      })
      return vote_map   
      }
    
   function timer(key){
         var countDownDate = new Date(end).getTime();
         // Update the count down every 1 second
         var x = setInterval(function() {
         // Get today's date and time
         var now = new Date().getTime();
         // Find the distance between now and the count down date
         var distance = countDownDate - now;
         // Time calculations for days, hours, minutes and seconds
         var days = Math.floor(distance / (1000 * 60 * 60 * 24));
         var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
         var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
         var seconds = Math.floor((distance % (1000 * 60)) / 1000);
         // Display the result in the element with id="demo"
         setTimer(`${days}d ${hours}h ${minutes}m ${seconds}s`)
         // If the count down is finished, write some text
         
         

         if (distance < 0) {
            clearInterval(x);
            setTimer(`expired`)
         }
         }, 1000);
         return
      }
   
      const stopTimer = () =>{
            try {
               clearInterval(window.interval)
            } catch (e) {
               console.log(`interval not initialized yet`);
            }  
      }
function toggleVtBox(){
   if((!mtgVtBox)){
      setMtgVtPos('slide-up')
      setMtgVtBox(true)

      window.localStorage.setItem('voteToggle',true)
      }else{
      setMtgVtPos('slide-down')
      setMtgVtBox(false)
      window.localStorage.setItem('voteToggle',false)
    
      }
      console.log("toggleMtgVt click")
}
function toggleQR(){   
   if(!showQr){
     setShowQr(true)
     setQrPos('qr-up')
     }else{
         setQrPos('qr-down')
       setShowQr(false)
         }
       console.log("toggleEventVid click")
     }
 
   useEffect(()=>{
      
      // console.log('Meeting votes: ', JSON.parse(localStorage.getItem('meeting')))
      if (!currentMeeting || currentMeeting === undefined ){setCurrentMeeting(JSON.parse(localStorage.getItem('meeting')))}
         try{
            let meeting = JSON.parse(localStorage.getItem('meeting'))

            setCurrentMeeting(meeting)

         }catch(er){
            console.log('No Meetings----Redirect-->:',er)
            setView('meetings')
            window.location.href = '/meetings'
         }
      if (!currentMeeting.OM_id){createOMRoom()}

   },[])

   //  if (showDuration){timer()}


   //  let vidLinkClass = `vid-link ${vidLinkMod} blink-faster`
    let qrLinkClass = `blink-faster`
   let mtg_vt_cls_ButtonClass = `vd-mt-vt-button show-box blink`
    return (
        <div className="meeting-container"> 

         <div className={qrLinkClass} id="meeting-qr-link" onClick={toggleQR}>     
               <img src="/images/qrcode.svg" alt='qr code icon'/>
         </div>
      
{/* 
      {((view === "vid-conf") && mtgVtBox ) &&( 
                  <div className ={mtgVtPos} id="vc-vt-frame">
                  <Vote  
                     user = {cur_user}
                     vote = {vote}
                     meetings = {meetings} 
                     votes = {votes} 
                     view = {props.view} 
                     setView = {props.setView}/>   
                  </div>
                  )}   */}

        <div className="meeting-header">
         <div className={status_class} id ="meeting-status">
            &#x2022;   {status}
         </div>
         <div className="meeting-comp-top-right" id="meeting-type">
            <span className={type}>{type}</span>
         </div>
       
           
            <h2 className="view-header blink-slower" id="view-header">"{title}"</h2>
            
            {/* <h4 className="color-grad-blue-text">"{title}"</h4> */}
            <span className="meeting_time_handling">
               {!showDuration&&(
                  <span className={time_class} id="meeting_time_handling" 
                        onClick={() => 
                        {setShowDuration(true)
                           timer()
                        }
                        }>
                        &#9663; {time_handling}-time 
                  </span> )}
               {showDuration&&( 
                     <span className= {time_class} id="meeting_time_handling"
                        onClick={() => 
                        { stopTimer()
                           setShowDuration(false)
                        }}
                        >&#9657; {time}</span>)} 
                    </span> 
               <div style={{display:'flex', flexDirection: 'row', justifyContent: 'space-between', width:'80%', margin:'auto'}}>

                  <div className = "meeting-attendees" id="meeting-attendees">
                     attendees: {attendees?.length}
                  </div>
               
                     <span>
                           {!showAdmin&&(
                           <span id="meeting-header-admin-tag"  className='blink' 
                                 onClick={() => setShowAdmin(true)}>
                                 admin &#9663;
                           </span> )}
                           {showAdmin&&( <span className="meeting-header-admin-info blink"
                           onClick={() => setShowAdmin(false)}
                           >{admin?.preferredName}&#9667;</span>)} 
                     </span>
               </div>
               </div>
            <div id='meeting-content-wrap'>
               <div className='meeting-content'>
                  &nbsp;
                  {/* {generateVotes(view)} */}
                  { votes? generateVotes(view):<h3 className='center'>No votes available</h3>}
                  <br></br>
                  <br></br>
                  &nbsp;
               </div>
            </div>
            <div className = {`qr-wrap ${qrPos}`}>
                       <div id="qr-modal-close" onClick={toggleQR}>close</div>
                        <QrModal user={props.user} tag={title}view={props.view}/>
                    </div>
        </div>
  );
}
export default Meeting; 